import { useSearchParams } from 'react-router-dom';

import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';

import { PropertyDetailsTab } from './PropertyDetailsTab';
import { LeasingDetailsTab } from './LeasingDetailsTab';

import type { PropertyEntity } from '../../../../types/property.types';

const VALID_TABS = ['details', 'leasing'] as const;
type TabValue = (typeof VALID_TABS)[number];

const parseTabParam = (raw: string | null): TabValue =>
  raw === 'leasing' ? 'leasing' : 'details';

interface Props {
  property: PropertyEntity;
}

export function PropertyDetailTabs({ property }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const active = parseTabParam(searchParams.get('tab'));

  const handleChange = (next: string) => {
    const value = parseTabParam(next);
    if (value === 'details') {
      // Default tab → no param in URL (cleaner).
      searchParams.delete('tab');
    } else {
      searchParams.set('tab', value);
    }
    setSearchParams(searchParams, { replace: true });
  };

  return (
    <Tabs value={active} onValueChange={handleChange} className="w-full">
      <TabsList>
        <TabsTrigger value="details">Property Details</TabsTrigger>
        <TabsTrigger value="leasing">Leasing Details</TabsTrigger>
      </TabsList>
      <TabsContent value="details" className="pt-6">
        <PropertyDetailsTab property={property} />
      </TabsContent>
      <TabsContent value="leasing" className="pt-6">
        <LeasingDetailsTab property={property} />
      </TabsContent>
    </Tabs>
  );
}
